export interface ProductSpec {
  icon: string;
  label: string;
  value: string;
}

export interface ProductData {
  id: string;
  slug: string;
  name: string;
  badge: string | null;
  image: string;
  images: string[];
  subtitle: string;
  description: string;
  specs: { potencia?: string; velocidade?: string; temperatura?: string; material?: string; [key: string]: string | undefined };
  fullSpecs: ProductSpec[];
  href: string;
  relatedSlugs: string[];
}

export const products: ProductData[] = [
  {
    id: 'bt950',
    slug: 'bt950',
    name: 'BT950',
    badge: 'Top Venda',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/ed01fec4-8068-4de2-aa2c-43347d8ea350_compressed_bt950-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/ed01fec4-8068-4de2-aa2c-43347d8ea350_compressed_bt950-1.webp',
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/f4ecf2e4-0d69-4686-8c22-e3be725e7c13_compressed_BT950-2.webp',
    ],
    subtitle: 'Máquina de Solda Geomembrana de Alta Performance',
    description: 'A máquina de solda de geomembrana BT950 é o modelo mais avançado da linha SoldaGeo, desenvolvida para projetos de grande escala que exigem máxima potência e precisão. Com solda por cunha quente de 2100W e controle digital de temperatura, garante emendas perfeitas em geomembranas de PEAD, PELBD e PVC de até 3,0 mm.',
    specs: { potencia: '2100w / 220v', velocidade: '5–8 m/min', temperatura: '0–500°C', material: '500–3000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2100w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '5–8 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–500°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–3000 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '11kg' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '40 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/bt950',
    relatedSlugs: ['bt1600', 'bt800', 'cx300-1400w'],
  },
  {
    id: 'bt1600',
    slug: 'bt1600',
    name: 'BT1600',
    badge: null,
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/c853d1c5-1e6f-477a-8234-02fe757ee1de_compressed_BT1600-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/c853d1c5-1e6f-477a-8234-02fe757ee1de_compressed_BT1600-1.webp',
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/9e13e2c3-8a94-44f0-af69-4db03a24a5f1_compressed_BT1600---CARACT.webp',
    ],
    subtitle: 'Soldagem Profissional para Geomembrana',
    description: 'A máquina de solda de geomembrana BT1600 combina robustez e versatilidade para atender projetos de médio e grande porte. Com solda por cunha quente de 1600W e controle preciso de temperatura, é a escolha ideal para equipes que buscam produtividade e qualidade de solda consistente em PEAD, PELBD e PVC.',
    specs: { potencia: '1600w / 220v', velocidade: '5 m/min', temperatura: '0–450°C', material: '400–2000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1600w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '5 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–450°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '400–2000 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '4,2 kg' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '40 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/bt1600',
    relatedSlugs: ['bt950', 'bt800', 'cx300-1400w'],
  },
  {
    id: 'bt800',
    slug: 'bt800',
    name: 'BT800',
    badge: null,
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/91b1b8d5-ac72-474b-bffd-9128a533bc4a_compressed_BT800-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/91b1b8d5-ac72-474b-bffd-9128a533bc4a_compressed_BT800-1.webp',
    ],
    subtitle: 'Compacto, Leve e Eficiente',
    description: 'A máquina de solda de geomembrana BT800 é a solução ideal para projetos de menor escala ou trabalhos em locais de difícil acesso. Com solda por cunha quente de 800W e design compacto, oferece mobilidade sem abrir mão da qualidade de solda profissional em PEAD, PELBD e PVC.',
    specs: { potencia: '800w / 220v', velocidade: '2–5 m/min', temperatura: '0–400°C', material: '500–1500 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '800w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '2–5 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–400°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–1500 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '4.5 kg' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '30 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '12 meses' },
    ],
    href: '/produto/bt800',
    relatedSlugs: ['bt950', 'bt1600', 'cx300-1400w'],
  },
  {
    id: 'cx300-1400w',
    slug: 'cx300-1400w',
    name: 'CX300 1400W',
    badge: null,
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/7b3ee0c6-e5a6-4ac6-b8de-0bbbbcafd1ea_compressed_cx300-1-webp.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/7b3ee0c6-e5a6-4ac6-b8de-0bbbbcafd1ea_compressed_cx300-1-webp.webp',
    ],
    subtitle: 'Precisão Suíça para Geomembrana',
    description: 'A Canex CX300 é uma máquina de solda de geomembrana por cunha quente reconhecida pela precisão e confiabilidade. Ideal para a soldagem de geomembranas de PEAD, PELBD e PVC em projetos que exigem o mais alto padrão de qualidade.',
    specs: { potencia: '1400w / 220v', velocidade: '0,5–6 m/min', temperatura: '450°C', material: '500–1800 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1400w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '0,5–6 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura Máx.', value: '450°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–1800 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '7 kg' },
      { icon: 'ri-global-line', label: 'Origem', value: 'china' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '40 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '12 meses' },
    ],
    href: '/produto/cx300-1400w',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'ex3',
    slug: 'ex3',
    name: 'Extrusora EX3',
    badge: 'Extrusão',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/172ef163-f638-4733-bdff-a0febe8d21e7_compressed_EX3-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/172ef163-f638-4733-bdff-a0febe8d21e7_compressed_EX3-1.webp',
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/0b541b2c-1c35-4eb1-88a8-eac2b1d4c0fb_compressed_EX3-2.webp',
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/6f33856b-f939-49db-ab2c-73a24d0cfc91_compressed_EX3-3.webp',
    ],
    subtitle: 'Extrusora Profissional para Geomembrana',
    description: 'A Extrusora EX3 Weldy é a ferramenta definitiva para soldagem por extrusão de geomembranas espessas. Com temperatura de trabalho de até 700°C e produção de 3,5 kg/h, é indispensável em projetos de PEAD, PELBD e PVC que exigem soldas de alta resistência mecânica.',
    specs: { potencia: '3400w', velocidade: '3,5 kg/H', temperatura: '700°C', material: 'Ø 3,0–4,0 mm' },
    fullSpecs: [
      { icon: 'ri-speed-line', label: 'Produção', value: '3,5 kg/H' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura Máx.', value: '700°C' },
      { icon: 'ri-stack-line', label: 'Diâmetro do Fio', value: 'Ø 3,0–4,0 mm' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-scales-line', label: 'Peso', value: '5,2 kg' },
      { icon: 'ri-global-line', label: 'Origem', value: 'Suíça' },
      { icon: 'ri-tools-line', label: 'Tipo de Solda', value: 'Extrusão' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '12 meses' },
    ],
    href: '/produto/ex3',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'wgw300',
    slug: 'wgw300',
    name: 'Weldy WGW300',
    badge: null,
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/c2845262-5c90-4a54-8471-e740db433cbc_compressed_WGW300-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/c2845262-5c90-4a54-8471-e740db433cbc_compressed_WGW300-1.webp',
    ],
    subtitle: 'Alta Performance para Grandes Obras',
    description: 'O Weldy WGW300 é uma máquina de solda de geomembrana por cunha quente de alta performance, ideal para grandes obras de impermeabilização. Com 2100W e velocidade de até 9 m/min, garante produtividade máxima em campo.',
    specs: { potencia: '2100w / 220v', velocidade: '5–9 m/min', temperatura: '500°C', material: '500–3000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2100w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '5–9 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '500°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–3000 mic' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/wgw300',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'bt-gm1',
    slug: 'bt-gm1',
    name: 'BT-GM1',
    badge: 'Novo',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/c6c29e02-c677-493e-acd4-c478a01b3421_compressed_BT-GM1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/c6c29e02-c677-493e-acd4-c478a01b3421_compressed_BT-GM1.webp',
    ],
    subtitle: 'Novo Modelo de Alta Precisão',
    description: 'O BT-GM1 é a mais nova máquina de solda de geomembrana da linha SoldaGeo, com controle digital avançado e alta precisão de soldagem. Projetado para atender projetos que exigem máxima confiabilidade e desempenho consistente.',
    specs: { potencia: '1800w / 220v', velocidade: '0.5–7 m/min', temperatura: '0–550°C', material: '500–2000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1800w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '0.5–7 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–550°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–2000 mic' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/bt-gm1',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'soprador-2000w-com-rolo',
    slug: 'soprador-2000w-com-rolo',
    name: 'Soprador 2000w com Rolo',
    badge: 'Acessório',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/5dedb7f2-8c0a-4ac6-b963-40bed076fc24_compressed_BT2000-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/5dedb7f2-8c0a-4ac6-b963-40bed076fc24_compressed_BT2000-1.webp',
    ],
    subtitle: 'Soprador Profissional com Rolo de Pressão',
    description: 'O Soprador 2000W com Rolo é o acessório ideal para soldagem manual de geomembrana. Com temperatura de até 650°C e rolo de pressão integrado, garante soldas precisas e resistentes em qualquer condição.',
    specs: { potencia: '2000w / 220v', velocidade: 'Manual', temperatura: '0–650°C', material: '200–2000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2000w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: 'Manual' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–650°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '200–2000 mic' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/soprador-2000w-com-rolo',
    relatedSlugs: ['bt950', 'ex3', 'extrusora-weldy-booster-ex3-plus'],
  },
  {
    id: 'extrusora-metabo-bt610a',
    slug: 'extrusora-metabo-bt610a',
    name: 'Extrusora Metabo BT610A',
    badge: 'novo modelo',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/96bd6c97-3fbd-49a4-a115-610334a6b2eb_compressed_BT610A.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/96bd6c97-3fbd-49a4-a115-610334a6b2eb_compressed_BT610A.webp',
    ],
    subtitle: 'Extrusora Metabo de Alta Potência',
    description: 'A Extrusora Metabo BT610A é o novo modelo de extrusora para soldagem de geomembranas espessas. Com 3400W de potência e temperatura de até 600°C, oferece alta produtividade e qualidade de solda superior.',
    specs: { potencia: '3400', velocidade: 'Manual', temperatura: '600', material: '3-4 mm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '3400W' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: 'Manual' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '600°C' },
      { icon: 'ri-stack-line', label: 'Diâmetro do Fio', value: '3-4 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/extrusora-metabo-bt610a',
    relatedSlugs: ['ex3', 'extrusora-weldy-booster-ex3-plus', 'bt950'],
  },
  {
    id: 'lc3000c',
    slug: 'lc3000c',
    name: 'LC3000C',
    badge: 'Profissional',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/3490d712-995b-4628-a272-c6f805dca703_compressed_LC3000C-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/3490d712-995b-4628-a272-c6f805dca703_compressed_LC3000C-1.webp',
    ],
    subtitle: 'Máquina Profissional de Alta Durabilidade',
    description: 'A LC3000C é uma máquina de solda de geomembrana profissional com alta durabilidade e desempenho consistente. Com 1800W e velocidade de até 7 m/min, é ideal para projetos de grande escala.',
    specs: { potencia: '1800w / 220v', velocidade: '3–7 m/min', temperatura: '0–600°C', material: '400–1100 µm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1800w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '3–7 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–600°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '400–1100 µm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/lc3000c',
    relatedSlugs: ['bt950', 'bt1600', 'wgw300'],
  },
  {
    id: 'weldy-wgw300-plus',
    slug: 'weldy-wgw300-plus',
    name: 'Weldy WGW300',
    badge: 'Alta Velocidade',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/201b4c8e-c9c0-48ba-b8ed-4fc56b92c488_compressed_WGW300PLUS-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/201b4c8e-c9c0-48ba-b8ed-4fc56b92c488_compressed_WGW300PLUS-1.webp',
    ],
    subtitle: 'Alta Velocidade para Grandes Projetos',
    description: 'Modelo de alta velocidade da linha Weldy WGW300, com 2000W e velocidade de até 8 m/min. Ideal para projetos de grande escala que exigem máxima produtividade na soldagem de geomembranas.',
    specs: { potencia: '2000w / 220v', velocidade: '4–8 m/min', temperatura: '0–520°C', material: '500–3000 µm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2000w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '4–8 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–520°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–3000 µm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/weldy-wgw300-plus',
    relatedSlugs: ['bt950', 'wgw300', 'bt1600'],
  },
  {
    id: 'extrusora-weldy-booster-ex3-plus',
    slug: 'extrusora-weldy-booster-ex3-plus',
    name: 'Extrusora Weldy Booster EX3 Plus',
    badge: 'Acessório',
    image: 'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/37d2299a-aa6f-4260-8329-a69a1c5b1d32_compressed_EX3PLUS-1.webp',
    images: [
      'https://storage.helloreaddy.io/project_files/217680d6-f843-4544-b1f8-1c690df6363d/37d2299a-aa6f-4260-8329-a69a1c5b1d32_compressed_EX3PLUS-1.webp',
    ],
    subtitle: 'Extrusora Weldy Booster de Alta Performance',
    description: 'A Extrusora Weldy Booster EX3 Plus é a versão aprimorada da EX3, com maior potência e produtividade. Com 3400W e temperatura de até 600°C, é a escolha ideal para projetos que exigem soldas de alta resistência mecânica.',
    specs: { potencia: '3400w / 220v', velocidade: 'Manual', temperatura: '0–600°C', material: '3-4 mm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '3400w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: 'Manual' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–600°C' },
      { icon: 'ri-stack-line', label: 'Diâmetro do Fio', value: '3-4 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/extrusora-weldy-booster-ex3-plus',
    relatedSlugs: ['ex3', 'extrusora-metabo-bt610a', 'bt950'],
  },
];
